import { useEffect, useState } from 'react';
import Subheader from '../Subheader';
import Table from '../Table/Table';
import Body from '../Body';
import Manage from './Manage';
import { _deletePost, _getPosts, _getCountries, Country } from 'routes/routes';
import { formatFlyerTable } from '../TableService';
import { useSnackbar } from 'notistack';
import useError from 'hooks/useError';
import { confirmDialog } from 'primereact/confirmdialog';
import { Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import './styles.css';
import OrderFlyers from './OrderFlyers';
const statuses = [
    {
        id: 0,
        name: 'Pending'
    },
    {
        id: 1,
        name: 'Posted'
    },
    {
        id: 2,
        name: 'Active'
    }
];
const List: React.FC = () => {
    const setError = useError();
    const { enqueueSnackbar } = useSnackbar();
    const [updateId, setUpdateId] = useState<number | null>(null);
    const [data, setData] = useState<any[]>([]);
    const [newData, setNewData] = useState<any[]>([]);
    const [redrawTable, setRedrawTable] = useState<Boolean>(false);
    const [isOpenManage, setIsOpenManage] = useState(false);
    const [action, setAction] = useState<string>('New');
    const [status, setStatus] = useState<string>('-1');
    const [selectedCountry, setselectedCountry] = useState<string>('-1');
    const [selectedOrderCountry, setSelectedOrderCountry] =
        useState<string>('-1');
    const [countries, setCountries] = useState<Country[]>([]);
    const [tab, setTab] = useState('1');
    const [resetFilters, setResetFilters] = useState<boolean>(false);
    useEffect(() => {
        if (!isOpenManage) {
            const fetchOptions = async () => {
                try {
                    const response = await _getPosts();
                    const countries = await _getCountries();
                    setCountries(countries.data);
                    setData(response.data);
                    setNewData(response.data);
                } catch (err) {
                    setError(err);
                }
            };
            setUpdateId(null);
            fetchOptions();
        }
    }, [isOpenManage, redrawTable]);
    const { formattedColumns, formattedRows } = formatFlyerTable(newData);

    useEffect(() => {
        if (resetFilters) {
            setSelectedOrderCountry('-1');
            setSelectedOrderCountry('-1');
            setStatus('-1');
            setResetFilters(false);
        }
    }, [resetFilters]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTab(newValue);
        setResetFilters(true);
    };

    const handleEdit = (id: number) => {
        // Logic to handle editing a row based on the provided ID
        // enqueueSnackbar('Item edited ', { variant: 'success' });
        setUpdateId(id);
        setAction('Edit');
        setIsOpenManage(true);
    };
    const handleOpenmanage = () => {
        setAction('New');
        setIsOpenManage(true);
    };
    // Function to handle deleting a row
    const handleDelete = async (id: number) => {
        const accept = async () => {
            try {
                await _deletePost(id);
                enqueueSnackbar('Item Deleted ', { variant: 'success' });
                setRedrawTable(!redrawTable);
            } catch (err) {
                setError(err);
            }
        };
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept
        });
    };
    const handleStatusChange = async (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setStatus(event.target.value);
    };
    useEffect(() => {
        const filtered_data = data;
        if (status != '-1' && selectedCountry != '-1') {
            const new_data = filtered_data.filter(
                (item) =>
                    item.status == status && item.country.id == selectedCountry
            );
            setNewData(new_data);
        } else if (status != '-1' && selectedCountry == '-1') {
            const new_data = filtered_data.filter(
                (item) => item.status == status
            );
            setNewData(new_data);
        } else if (status == '-1' && selectedCountry != '-1') {
            const new_data = filtered_data.filter(
                (item) => item.country.id == selectedCountry
            );
            setNewData(new_data);
        } else if (status == '-1' && selectedCountry == '-1') {
            setNewData(data);
        } else {
            setNewData(data);
        }
    }, [status, selectedCountry]);
    const handleSelectChange = async (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setselectedCountry(event.target.value);
    };
    const selectoptions = (
        <div className="custom-select">
            <select
                id="options"
                className="select-countries custom-select"
                value={selectedCountry}
                onChange={handleSelectChange}
            >
                <option key={-1} value={-1}>
                    All Countries
                </option>
                {countries.map((country) => (
                    <option key={country.id} value={country.id}>
                        {country.name}
                    </option>
                ))}
            </select>
        </div>
    );
    const handleSelectOrderChange = async (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedOrderCountry(event.target.value);
    };
    const selectOrderOptions = (
        <div className="custom-select">
            <select
                id="options"
                className="select-countries custom-select"
                style={{ padding: '7px' }}
                value={selectedOrderCountry}
                onChange={handleSelectOrderChange}
            >
                <option key={-1} value={-1}>
                    Select Country
                </option>
                {countries.map((country) => (
                    <option key={country.id} value={country.id}>
                        {country.name}
                    </option>
                ))}
            </select>
        </div>
    );

    const statusSelect = (
        <div className="custom-select">
            <select
                id="options"
                className="select-countries custom-select"
                value={status}
                onChange={handleStatusChange}
            >
                <option key={-1} value={-1}>
                    All Statuses
                </option>
                {statuses.map((status) => (
                    <option key={status.id} value={status.id}>
                        {status.name}
                    </option>
                ))}
            </select>
        </div>
    );
    const handleClose = () => {
        setIsOpenManage(false);
        setselectedCountry('-1');
        setStatus('-1');
    };
    return (
        <div className="h-full" style={{ height: '100%' }}>
            {isOpenManage ? (
                <div className="h-full">
                    <Manage
                        onClose={handleClose}
                        onSave={() => setRedrawTable(!redrawTable)}
                        type={action}
                        updateId={updateId}
                    />
                </div>
            ) : (
                <div style={{ height: '100%' }}>
                    <div className="h-[120px] p-4 rounded-t-lg flex justify-between items-center px-[50px]">
                        <div>
                            <h1 className="text-xl font-bold text-[#707070]">
                                Flyers
                            </h1>
                        </div>
                        <div>
                            {/* Toggle the visibility of Manage component */}
                            <button
                                className="custom-input px-4 py-2 bg-[#72BF45] w-[161px] h-38px text-white rounded-md"
                                onClick={handleOpenmanage}
                            >
                                +Add Flyer
                            </button>
                        </div>
                    </div>
                    <Box
                        sx={{
                            width: '100%',
                            height: 'calc(100% - 120px)',
                            typography: 'body1'
                        }}
                    >
                        <TabContext value={tab}>
                            <Box
                                sx={{
                                    borderBottom: 1,
                                    borderTop: 1,
                                    borderColor: 'divider'
                                }}
                            >
                                <TabList
                                    onChange={handleTabChange}
                                    aria-label="lab API tabs example"
                                >
                                    <Tab label="List" value="1" />
                                    <Tab label="Order" value="2" />
                                </TabList>
                            </Box>
                            <TabPanel
                                value="1"
                                sx={{ padding: 0, height: '100%' }}
                            >
                                <Subheader
                                    multiSelectComponent={selectoptions}
                                    secondMultiSelect={statusSelect}
                                    description="Filter Countries and Statuses"
                                />
                                <Body
                                    height="calc(100% - 130px)"
                                    content={
                                        <Table
                                            rows={formattedRows}
                                            columns={formattedColumns}
                                            searchClass="search-flyer"
                                            onEdit={handleEdit}
                                            onDelete={handleDelete}
                                        />
                                    }
                                />
                            </TabPanel>
                            <TabPanel
                                value="2"
                                sx={{
                                    padding: 0,
                                    height: 'calc(100% - 50px)'
                                }}
                            >
                                <Subheader
                                    multiSelectComponent={selectOrderOptions}
                                    description="Please Select Country"
                                />
                                <Body
                                    height="calc(100% - 80px)"
                                    content={
                                        <OrderFlyers
                                            selectedCountry={
                                                selectedOrderCountry
                                            }
                                            // data={data}
                                        ></OrderFlyers>
                                    }
                                />
                            </TabPanel>
                        </TabContext>
                    </Box>
                </div>
            )}
        </div>
    );
};

export default List;
